import { createI18n } from 'vue-i18n'
import zhCN from './locales/zh-CN.js'
import enUS from './locales/en-US.js'
import viVN from './locales/vi-VN.js'
import zhTW from './locales/zh-TW.js'

// 获取默认语言：默认英文，但仍尊重 URL 参数与用户已保存的偏好
function getDefaultLocale() {
  // 1. URL 参数 ?lang= 优先级最高（便于 SEO/分享/爬虫识别语言版本）
  const params = new URLSearchParams(window.location.search)
  const urlLang = params.get('lang')
  if (urlLang && ['zh-CN', 'en-US', 'vi-VN', 'zh-TW'].includes(urlLang)) {
    return urlLang
  }

  // 2. localStorage 中保存的语言（用户显式切换后的偏好）
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && ['zh-CN', 'en-US', 'vi-VN', 'zh-TW'].includes(savedLocale)) {
    return savedLocale
  }

  // 3. 默认英文（不再跟随浏览器语言，确保网站默认以英文打开）
  return 'en-US'
}

const i18n = createI18n({
  legacy: false, // 使用Composition API模式
  locale: getDefaultLocale(),
  fallbackLocale: 'en-US', // 回退语言
  warnHtmlMessage: false, // 禁用HTML警告
  escapeHtml: true, // 转义HTML
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
    'vi-VN': viVN,
    'zh-TW': zhTW
  }
})

export default i18n